/**
 * Client app enhancement file.
 *
 * https://v1.vuepress.vuejs.org/guide/basic-config.html#app-level-enhancements
 */
// VIEW MD
import ViewMd from 'iuvity-ui-vue-components/dist/components/ViewMd/index.vue'
// COMPONENTS IUVITY-UI-VUE-COMPONENTS
import {
  CardList,
  Accordion,
  AccordionTab,
  Headers,
  TipError,
  Mensajeriat1json,
  ShowCharacter,
  ShowText,
  Space,
  Dialog
} from 'iuvity-ui-vue-components'
// CONFIGURACIONES PARA TENER TODOS LOS ESTILOS DE PRIMEVUE
import 'iuvity-ui-vue-components/dist/styles.css'
import 'iuvity-ui-vue-components/dist/iuvity-ui-vue-components.css'
import 'primeflex/primeflex.css'
import 'primevue/resources/themes/saga-blue/theme.css'       //theme
import 'primevue/resources/primevue.min.css'                 //core css
import 'primeicons/primeicons.css'
import PrimeVue from 'primevue/config'
// COMPONENTES PROPIOS
import LandingComponent from './components/LandingComponent'
// OTROS COMPONENTES DE PRIMEVUE
import ToastService from 'primevue/toastservice'
import Button from 'primevue/button'
// VALIDADOR DE INPUTS
import Vuelidate from 'vuelidate'
// REDER PARA MARKDOWN PROPIO
import {findPageForPath} from '@app/util'

export default ({
  Vue, // the version of Vue being used in the VuePress app
  options, // the options for the root Vue instance
  router, // the router instance for the app
  siteData // site metadata
}) => {
  // ...apply enhancements for the site.
  // VALIDAR FORMATO MARKDOWN
  Vue.mixin({
    methods: {
      getPageKey(pages, path) {
        const result = findPageForPath(pages, path)
        return result.key
      }
    }
  })
  // COMPONENTES
  Vue.component('ViewMd', ViewMd)
  Vue.component('CardList', CardList)
  Vue.component('Accordion', Accordion)
  Vue.component('AccordionTab', AccordionTab)
  Vue.component('headers', Headers)
  Vue.component('tipError', TipError)
  Vue.component('mensajeriat1json', Mensajeriat1json)
  Vue.component('ShowCharacter', ShowCharacter)
  Vue.component('ShowText', ShowText)
  Vue.component('Space', Space)
  Vue.component('Space', Space)
  Vue.component('DialogComponent', Dialog)
  Vue.component('Button', Button)
  // VARIBALE GLOBAL
  Vue.prototype.hostname = 'hostname'
  Vue.use(ToastService)
  Vue.use(Vuelidate)
  Vue.use(PrimeVue)
  // ADICIONAR RUTAS
  router.addRoute({
    path: "/",
    redirect: "/portal",
  })
  router.addRoute({
    path: '/portal',
    component: LandingComponent
  })
  // VARIABLES GLOBALES EN VUEPRESS
  window.global ||= window
  if (typeof window !== "undefined") {
    window.siteData = siteData
  }
}
